/**************************************************
 * Nombre:       Educacion_Cursos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import Tarjeta_Oferta from "../../Tarjetas/Tarjeta_Oferta";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";


const Educacion_Cursos = () => {
    const cData = useContext(contexApp)
    const {sCell, masSM} = useResponsive()
    const [cursos, setCursos] = useState([])


    useEffect(() => {

        if (cData.cursos && cData.cursos.length <= 1) {
            setCursos(cData.cursos)
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', p: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        {cursos.map((item, index) => (
                            <Grid container size={{xs: 12, sm: 3, md: 6}}>
                                <Tarjeta_Oferta item={item} index={index}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Educacion_Cursos

const items = [1]

